import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Box,
  Typography,
} from '@mui/material';

import StockDiscovery from './StockDiscovery';
import MarketETFsAnalysis from '../tools/MarketETFsAnalysis';
import SectorETFsAnalysis from '../tools/SectorETFsAnalysis';

interface InvestorToolsPageProps {
  urlPrimaryBase: string;
  onTickerSelect: (ticker: string) => void;
}

const InvestorToolsPage: React.FC<InvestorToolsPageProps> = ({ urlPrimaryBase, onTickerSelect }) => {
  const location = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const section = searchParams.get('section') || 'market-etfs'; // Default section

  // Placeholder content for other sections
  const renderSectionContent = () => {
    switch (section) {
      case 'discovery':
        return <StockDiscovery onTickerSelect={onTickerSelect} />;
      case 'market-etfs':
        return <MarketETFsAnalysis />;
      case 'sector-etfs':
        return <SectorETFsAnalysis />;
      case 'heatmap':
        return <Typography variant="h5">Market Heatmap (Placeholder)</Typography>;
      default:
        return <Typography variant="h5">Unknown Tool Section</Typography>;
    }
  };

  return (
    <Box>
      {renderSectionContent()}
    </Box>
  );
};

export default InvestorToolsPage;